import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Switchcamera = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9 9.438a.5.5 0 0 0-1 0v1.625c0 .483.392.875.875.875h1.5a.5.5 0 0 0 0-1h-.854c.641-.618 1.524-1 2.479-1a3.5 3.5 0 0 1 3.5 3.5.5.5 0 0 0 1 0 4.5 4.5 0 0 0-4.5-4.5 4.58 4.58 0 0 0-3 1.122zm-.5 4a.5.5 0 1 0-1 0 4.5 4.5 0 0 0 4.5 4.5 4.58 4.58 0 0 0 3.006-1.127v.627a.5.5 0 0 0 1 0v-1.625a.875.875 0 0 0-.875-.875h-1.625a.5.5 0 1 0 0 1h.973c-.641.618-1.524 1-2.479 1a3.5 3.5 0 0 1-3.5-3.5'
          fill='currentColor'
        />
        <path
          d='M8.074 4.774a3 3 0 0 1 2.496-1.336h2.86a3 3 0 0 1 2.496 1.336l.812 1.219a1 1 0 0 0 .832.445H19a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h1.43a1 1 0 0 0 .832-.445z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.57 3.438a3 3 0 0 0-2.496 1.336l-.812 1.219a1 1 0 0 1-.832.445H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3h-1.43a1 1 0 0 1-.832-.445l-.812-1.22a3 3 0 0 0-2.496-1.335zm-1.57 6a.5.5 0 0 0-1 0v1.625c0 .483.392.875.875.875h1.5a.5.5 0 0 0 0-1h-.854c.641-.618 1.524-1 2.479-1a3.5 3.5 0 0 1 3.5 3.5.5.5 0 0 0 1 0 4.5 4.5 0 0 0-4.5-4.5 4.58 4.58 0 0 0-3 1.122zm-.5 4a.5.5 0 1 0-1 0 4.5 4.5 0 0 0 4.5 4.5 4.58 4.58 0 0 0 3.006-1.127v.627a.5.5 0 0 0 1 0v-1.625a.875.875 0 0 0-.875-.875h-1.625a.5.5 0 1 0 0 1h.973c-.641.618-1.524 1-2.479 1a3.5 3.5 0 0 1-3.5-3.5'
        fill='currentColor'
      />
    )}
  </IconBase>
);
